export default __webpack_public_path__ + "static/media/2.ab6fb0ff.jpg";